export enum EventColor {
    plum = 'plum',
    terracotta = 'terracotta',
    coral = 'coral',
    rose = 'rose',
    violet = 'violet',
    blue = 'blue',
    teal = 'teal',
    green = 'green',
    olive = 'olive',
    gold = 'gold',
}

export type EventColorOption = {
    key: EventColor;
    background: string;
    foreground: string;
};

export const DEFAULT_EVENT_COLOR = EventColor.plum;

export const INTERNAL_EVENT_COLOR = {
    background: '#FFE9AA',
    foreground: '#4B2F3E',
} as const;

export const EVENT_COLOR_OPTIONS: EventColorOption[] = [
    {
        key: EventColor.plum,
        background: '#4B2F3E',
        foreground: '#FFF3EB',
    },
    {
        key: EventColor.terracotta,
        background: '#FFDFC9',
        foreground: '#4B2F3E',
    },
    {
        key: EventColor.coral,
        background: '#B94C4C',
        foreground: '#FFFFFF',
    },
    {
        key: EventColor.rose,
        background: '#A64D79',
        foreground: '#FFFFFF',
    },
    {
        key: EventColor.violet,
        background: '#7456A4',
        foreground: '#FFFFFF',
    },
    {
        key: EventColor.blue,
        background: '#3F6FA6',
        foreground: '#FFFFFF',
    },
    {
        key: EventColor.teal,
        background: '#2F7D78',
        foreground: '#FFFFFF',
    },
    {
        key: EventColor.green,
        background: '#6E9058',
        foreground: '#FFFFFF',
    },
    {
        key: EventColor.olive,
        background: '#7A742F',
        foreground: '#FFFFFF',
    },
    {
        key: EventColor.gold,
        background: '#B7791F',
        foreground: '#FFFFFF',
    },
];

const EVENT_COLORS_BY_KEY = EVENT_COLOR_OPTIONS.reduce(
    (colors, option) => ({
        ...colors,
        [option.key]: option,
    }),
    {} as Record<EventColor, EventColorOption>,
);

export const getEventColor = (color?: EventColor): EventColorOption =>
    EVENT_COLORS_BY_KEY[color ?? DEFAULT_EVENT_COLOR] ??
    EVENT_COLORS_BY_KEY[DEFAULT_EVENT_COLOR];
